export const kanbanColumns = [
  { id: 'novo_lead', title: 'NOVO LEAD' },
  { id: 'qualificacao', title: 'QUALIFICAÇÃO' },
  { id: 'orcamento', title: 'ORÇAMENTO' },
  { id: 'negociacao', title: 'NEGOCIAÇÃO' },
  { id: 'fechado', title: 'FECHADO' },
  { id: 'sem_venda', title: 'ENCERRADO SEM VENDA' },
];
